export const PARAM_KEY_VERTICAL_SIGNING = "verticalSigning"
export const VERTICAL_SIGNING_CODE_URL_PARAM = "verticalSigningType"
export const VERTICAL_SIGNING_CONDITION_URL_PARAM = "verticalSigningCondition"
export const VERTICAL_SIGNING_TAGS_URL_PARAM = "verticalSigningTags"

export const PARAM_KEY_HORIZONTAL_SIGNING = "horizontalSigning"
export const HORIZONTAL_SIGNING_CODE_URL_PARAM = "horizontalSigningType"
export const HORIZONTAL_SIGNING_CONDITION_URL_PARAM = "horizontalSigningCondition"
export const HORIZONTAL_SIGNING_TAGS_URL_PARAM = "horizontalSigningTags"

export const PARAM_KEY_EQUIPMENT = "equipment"
export const EQUIPMENT_CODE_URL_PARAM = "equipmentType"
export const EQUIPMENT_CONDITION_URL_PARAM = "equipmentCondition"
export const EQUIPMENT_TAGS_URL_PARAM = "equipmentTags"